export default function test(str) {
    if (!str) return true;
    // regexp based check, allow only IPv4 for now, TODO extend to IPv6
    return /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(str);
}


